import Naluri from '~/common/api/naluri';
import {
  COMMON_GET_SUPPORT_GROUPS_BEGIN,
  COMMON_GET_SUPPORT_GROUPS_SUCCESS,
  COMMON_GET_SUPPORT_GROUPS_FAILURE,
  COMMON_GET_SUPPORT_GROUPS_DISMISS_ERROR,
} from './constants';
import isEmpty from 'lodash/isEmpty';
import moment from 'moment';

// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function getSupportGroups(initial = 1) {
  return (dispatch, getState) => {
    // optionally you can have getState as the second argument
    dispatch({
      type: COMMON_GET_SUPPORT_GROUPS_BEGIN,
    });

    // Return a promise so that you could control UI flow without states in the store.
    // For example: after submit a form, you need to redirect the page to another when succeeds or show some errors message if fails.
    // It's hard to use state to manage it, but returning a promise allows you to easily achieve it.
    // e.g.: handleSubmit() { this.props.actions.submitForm(data).then(()=> {}).catch(() => {}); }
    const promise = new Promise((resolve, reject) => {
      // doRequest is a placeholder Promise. You should replace it with your own logic.
      // See the real-word example at:  https://github.com/supnate/rekit/blob/master/src/features/home/redux/fetchRedditReactjsList.js
      // args.error here is only for test coverage purpose.
      const {
        common: { groupsPagination },
      } = getState();
      const page = initial ? initial : groupsPagination ? groupsPagination.page + 1 : 1;
      const params = {
        page: page,
        label: 'groups',
      };

      const doRequest = Naluri.get(`/api/expert/channels/groups`, params);
      doRequest.then(
        res => {
          dispatch({
            type: COMMON_GET_SUPPORT_GROUPS_SUCCESS,
            data: res,
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        err => {
          dispatch({
            type: COMMON_GET_SUPPORT_GROUPS_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

const allocateSponsorTabs = (state, sponsors) => {
  let sponsorsArray = [...sponsors];
  let sponsorTabs = state.sponsorTabs;

  if (isEmpty(sponsorTabs)) {
    sponsorsArray.forEach(sponsor => {
      const pair = {
        [sponsor]: []
      };
      sponsorTabs = {
        ...sponsorTabs,
        ...pair
      };
    });
  } else {
    sponsorsArray.forEach(sponsor => {
      if (!Object.keys(sponsorTabs).includes(sponsor)) {
        const pair = {
          [sponsor]: []
        };
        sponsorTabs = {
          ...sponsorTabs,
          ...pair
        };
      }
    });
  }

  return sponsorTabs;
};

const allocateSupportGroups = (sponsorTabs, groups) => {
  let groupsArray = [...groups];

  groupsArray.map(group => {
    const index = sponsorTabs[group.sponsor].findIndex(e => e.cid === group.cid);
    if (index === -1) {
      return sponsorTabs[group.sponsor].push(group);
    }
    return sponsorTabs[group.sponsor];
  });

  return sponsorTabs;
};

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissGetSupportGroupsError() {
  return {
    type: COMMON_GET_SUPPORT_GROUPS_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case COMMON_GET_SUPPORT_GROUPS_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        getSupportGroupsPending: true,
        getSupportGroupsError: null,
      };

    case COMMON_GET_SUPPORT_GROUPS_SUCCESS:
      // The request is success
      const { channels, sponsors, groups } = action.data;
      const updateChannels = state.channels.concat(channels);
      const updateGroups = state.groups.concat(groups);

      let sponsorTabs = state.sponsorTabs;

      if (!isEmpty(sponsors)) {
        sponsorTabs = allocateSponsorTabs(state, sponsors);
      }

      if (!isEmpty(groups)) {
        sponsorTabs = allocateSupportGroups(sponsorTabs, groups);
      }

      let pagination = state.groupsPagination;
      if (action.data.pagination) {
        pagination = action.data.pagination;
      }

      return {
        ...state,
        groupSponsors: sponsors,
        sponsorTabs: sponsorTabs,
        channels: updateChannels,
        groups: updateGroups,
        groupsPagination: pagination,
        getSupportGroupsPending: false,
        getSupportGroupsError: null,
        groupApiSentRequestTime: moment(),
      };

    case COMMON_GET_SUPPORT_GROUPS_FAILURE:
      // The request is failed
      return {
        ...state,
        getSupportGroupsPending: false,
        getSupportGroupsError: action.data.error,
      };

    case COMMON_GET_SUPPORT_GROUPS_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        getSupportGroupsError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/common/redux/getSupportGroups.js